<template>
    <div v-if="minutos">
        <v-icon color="success" class="pa-1">fa-clock</v-icon>
        <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{ cuentaRegresiva ?
        cuentaRegresiva.format('HH') : '00' }}</strong></v-chip>
        <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{ cuentaRegresiva ?
        cuentaRegresiva.format('mm') : '00' }}</strong></v-chip>
        <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{ cuentaRegresiva ?
                cuentaRegresiva.format('ss') : '00'}}</strong></v-chip>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'RelojRegresivo',
    props: {
        id: {
            type: Number,
            required: false
        },
        minutos: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            cuentaRegresiva: null,
            expiraEn: null,
            intervalo: null,
            fechaInicio: null,
            minutosDefasados: 0
        }
    },
    watch:{
        expiraEn(e){
            console.log(e);
        }
    },
    created() {
        this.fechaInicio = sessionStorage.getItem(`fechaInicioInterval${this.id}`) != null ? sessionStorage.getItem(`fechaInicioInterval${this.id}`) : moment.utc(new Date().toISOString());
    },
    beforeMount() {
        window.addEventListener("beforeunload", this.EstablecerFechaDefasada);
    },
    mounted() {
        if (sessionStorage.getItem(`fechaInicioInterval${this.id}`) != null) {
            this.minutosDefasados = moment.utc(new Date().toISOString()).diff(this.fechaInicio, 'seconds') / 60;
        }
        // this.cuentaRegresiva = moment.utc(this.minutos * 60000);
        this.expiraEn = (this.minutos - this.minutosDefasados) * 60;

        console.log('expira en ', this.expiraEn);

        this.EstablecerIntervalo();
    },
    beforeDestroy() {
        // window.addEventListener("beforeunload", this.EstablecerFechaDefasada);
        this.EstablecerFechaDefasada();
        window.removeEventListener("beforeunload");
    },
    methods: {
        EstablecerIntervalo: function () {
            this.intervalo = setInterval(() => {
                if (this.expiraEn === 0) {
                    clearInterval(this.intervalo);
                    this.fechaInicio = null;
                    sessionStorage.removeItem(`fechaInicioInterval${this.id}`);
                    this.$emit("expirado", this.id);

                    console.log('esta es la id ', this.id);

                } else {
                    this.expiraEn -= 1;
                    if (this.expiraEn === 0) {
                        this.cuentaRegresiva = null;
                    } else {
                        this.cuentaRegresiva = moment.utc(this.expiraEn * 1000).subtract(1, 'seconds');
                        // this.cuentaRegresiva = null;
                    }
                }
            }, 1000);
        },
        EstablecerFechaDefasada: function () {
            if (this.expiraEn > 0) {
                sessionStorage.setItem(`fechaInicioInterval${this.id}`, this.fechaInicio);
            } else {
                sessionStorage.removeItem(`fechaInicioInterval${this.id}`);
                clearInterval(this.interval);
                this.cuentaRegresiva = null;
                this.fechaInicio = null;
            }
        }
    }
}
</script>